"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import { useAppShellContext } from "../AppShell.context.mjs";
import AppShell_module_default from "../AppShell.module.mjs";
import "react";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/AppShell/AppShellNavbar/AppShellNavbar.tsx
const AppShellNavbar = factory((_props) => {
	const { classNames, className, style, styles, unstyled, vars, withBorder, zIndex, mod, ...others } = useProps("AppShellNavbar", null, _props);
	const ctx = useAppShellContext();
	if (ctx.disabled) return null;
	return /* @__PURE__ */ jsx(Box, {
		component: "nav",
		mod: [{ "with-border": withBorder ?? ctx.withBorder }, mod],
		...ctx.getStyles("navbar", {
			className,
			classNames,
			styles,
			style
		}),
		...others,
		__vars: { "--app-shell-navbar-z-index": `calc(${zIndex ?? ctx.zIndex} + 1)` }
	});
});
AppShellNavbar.classes = AppShell_module_default;
AppShellNavbar.displayName = "@mantine/core/AppShellNavbar";
//#endregion
export { AppShellNavbar };

//# sourceMappingURL=AppShellNavbar.mjs.map